export const smallPrint = {
  borderTop: ({ colors = {} }) => `1px solid ${colors['grey-10']}`,
  pt: [32, 32, 64],
  mb: [48, 64]
}

export const header = {
  mb: '24px'
}
